const templates = [
    {
        'id': 0,
        'template': 'When {{subspace}}, in general, there is a {{positive/negative}} correlation between {{measure1}} and {{measure2}}.',
    },
    {
        'id': 1,
        'template': 'When {{subspace}}, in general, {{measure2}} has a {{positive/negative}} relationship with {{measure1}}.',
    },
    {
        'id': 2,
        'template': 'When {{subspace}}, in general, {{measure2}} has a {{positive/negative}} relationship with {{measure1}} (Pearson correlation coefficient = {{parameter}}).',
    },
]

export default templates;